import React from "react";
import { LoadingIndicator } from "@company-mrv/mrv-design-system/components";

import plugin from "utils/currentPlugin";
import * as Styled from "./styles";

const LoadingWrapper = () => (
  <Styled.Container>
    <LoadingIndicator theme={plugin ? plugin.name : ""} />
  </Styled.Container>
);

export default LoadingWrapper;
